import React, {   useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Divider, Grid } from '@material-ui/core';
import { ServiceValues } from '../../../../../values/ServiceValues';
import { ServiceAxios } from '../../../../../services/ServiceEW';
import { useStyles } from './ModalidadeGeralStyles';
import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ModalidadeDetalhes from '../ModalidadeDetalhes/ModalidadeDetalhes';
import { deleteModalidade } from '../../../../../services/VisitaFiliadoModalidadeService';
import DialogConfirmacao from '../../../../../components/DialogConfirmacao/DialogConfirmacao';
import DeleteIcon from '@material-ui/core/SvgIcon/SvgIcon';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions/ExpansionPanelActions';
import { getVisitaFiliado } from '../../../../../services/VisitaFiliadoService';
import { Values } from '../../../../../values/Values';
import { useTheme } from '@material-ui/styles';

function ModalidadeGeral(props) {
  const {
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    setLoading,
    edicao,
    visitaFiliado,
    setVisitaFiliado,
    indexModalidade,
    armas,
    insumos,
    pacotes
  } = props;
  const classes = useStyles();
  const [refreshState, setRefreshState] = useState(new Date());
  const [expandedModalidade, setExpandedModalidade] = useState();
  const [expandedDetalhes, setExpandedDetalhes] = useState();
  const [abrirDialogConfirmacaoDeletarModalidade, setAbrirDialogConfirmacaoDeletarModalidade] = useState(false);
  const theme = useTheme();


  const handleChange = panel => (event, isExpanded) => {
    setExpandedModalidade(isExpanded ? panel : false);
  };

  async function getVisita() {
    try {
      setLoading(true);
      let dados = await getVisitaFiliado(visitaFiliado);
      if(dados.isSuccess) {
        setLoading(false);
        setVisitaFiliado(dados.result[0]);
      }
      else {
        setLoading(false);
        setTypeSnack('warning');
        setMessageSnack(dados.message);
        setShowMessageSnack(true);
      }

    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  async function deletar() {
    try {
      setAbrirDialogConfirmacaoDeletarModalidade(false);
      setLoading(true);
      let dados = await deleteModalidade(visitaFiliado.visitaFiliadoMods[indexModalidade].idVisitaFiliadoMod);
      if(dados.isSuccess) {
        setLoading(false);
        await getVisita();
        setLoading(false);
        setTypeSnack('success');
        setMessageSnack(dados.message);
        setShowMessageSnack(true);
      }
      else {
        setLoading(false);
        setTypeSnack('warning');
        setMessageSnack(dados.message);
        setShowMessageSnack(true);
      }
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(e.toString());
      setShowMessageSnack(true);
    }
  }

  return (
    <Grid
      container
    >
      <Grid
        item
        md={12}
        xs={12}
      >
        <DialogConfirmacao
          mensagemBotaoEsquerda={'CANCELAR'}
          mensagemBotaoDireita='SIM'
          acaoBotaoEsquerda={() => {setAbrirDialogConfirmacaoDeletarModalidade(false)}}
          acaoBotaoDireita={deletar}
          mensagemPrincipal='Tem certeza que deseja deletar essa modalidade?'
          tituloDialog={'Deletar modalidade?'}
          open={abrirDialogConfirmacaoDeletarModalidade}
        />
      </Grid>
      <Grid
        md={12}
        xs={12}
      >
        <ExpansionPanel
          expanded={expandedModalidade === 'panel1'}
          onChange={handleChange('panel1')}
          variant={'elevation'}
          style={{
            marginRight: 15,
            marginLeft: 15,
            marginBottom: 15
          }}
        >
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography className={classes.heading}>{'#' + (indexModalidade + 1) + ' ' + visitaFiliado.visitaFiliadoMods[indexModalidade].modalidade.descricao}</Typography>
            <Typography className={classes.secondaryHeading}>{'Acompanhamento de detalhes para modalidade ' + visitaFiliado.visitaFiliadoMods[indexModalidade].modalidade.descricao}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
          <Grid
              container
            >
              <Grid
                item
                md={12}
                xs={12}
              >
                  <ModalidadeDetalhes
                    visitaFiliado={visitaFiliado}
                    setVisitaFiliado={setVisitaFiliado}
                    expandedDetalhes={expandedDetalhes}
                    setExpandedDetalhes={setExpandedDetalhes}
                    indexModalidade={indexModalidade}
                    indexVisitaFiliadoTrap={0}
                    setShowMessageSnack={setShowMessageSnack}
                    setMessageSnack={setMessageSnack}
                    setTypeSnack={setTypeSnack}
                    setLoading={setLoading}
                    armas={armas}
                    insumos={insumos}
                    pacotes={pacotes}
                  />
              </Grid>
            </Grid>
          </ExpansionPanelDetails>
          <Divider />
          <ExpansionPanelActions>
            <Grid
              container
              spacing={2}
              style={{
                display: 'flex',
                justifyContent: 'flex-start'
              }}
            >
              <Grid
                item
                md={3}
                xs={12}
              >
                <Button
                  variant="contained"
                  color={'primary'}
                  onClick={e => setAbrirDialogConfirmacaoDeletarModalidade(true)}
                  startIcon={<DeleteIcon />}
                  fullWidth
                  style={{backgroundColor: theme.palette.error.main}}
                >
                  DELETAR MODALIDADE
                </Button>
              </Grid>
            </Grid>

          </ExpansionPanelActions>
        </ExpansionPanel>
      </Grid>

    </Grid>
  );
}

ModalidadeGeral.propTypes = {
  className: PropTypes.string,
  visitaFiliado: PropTypes.object.isRequired,
  setVisitaFiliado: PropTypes.object.isRequired
};

export default ModalidadeGeral;


